import React from 'react';

function Testimonials() {
  return (
    <section className="tc-testimonials-style1">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <h6 className="fsz-18 text-uppercase lh-4">
              what clients say <br /> about us
            </h6>
            <div className="lg-icon color-orange1">
              <i className="la la-quote-right"></i>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="tc-clients-style1">
              <div className="clients-slider1">
                <div className="swiper-wrapper">

                  {/* CARD 1 */}
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div
                        className="text js-splittext-lines"
                        style={{
                          fontSize: "20px",
                          lineHeight: "1.7",
                          fontWeight: "400",
                          maxWidth: "700px",
                        }}
                      >
                        "RED ANT STUDIO LLP transformed our vision for a modern, student-centric school building into a vibrant learning environment. 
                        Their team understood the heritage and purpose of Lady Willingdon and delivered a design that is functional, safe, and inspiring for our students. The project was executed with remarkable professionalism, clarity, and commitment."
                      </div>

                      <div className="author">
                        <div className="au-img">
                          <img src="/home1/assets/img/team/icon.jpg" alt="" className="img-cover" />
                        </div>
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">xxx</h6>
                          <p className="text-capitalize fsz-14 color-666">
                            Management, Lady Wellingdon School
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* CARD 2 */}
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div
                        className="text js-splittext-lines"
                        style={{
                          fontSize: "20px",
                          lineHeight: "1.7",
                          fontWeight: "400",
                          maxWidth: "700px",
                        }}
                      >
                        "The rejuvenation of our community pond by RED ANT STUDIO LLP has restored both its ecological health and its cultural value. 
                        Their thoughtful design, sustainable approach, and hands-on coordination brought the space back to life. Today, the pond stands as a beautiful public asset, and we are deeply grateful for their impactful work."
                      </div>

                      <div className="author">
                        <div className="au-img">
                          <img src="/home1/assets/img/team/icon.jpg" alt="" className="img-cover" />
                        </div>
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">xxx</h6>
                          <p className="text-capitalize fsz-14 color-666">
                            Local Community Representatives, Allikulam Lake
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* CARD 3 */}
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div
                        className="text js-splittext-lines"
                        style={{
                          fontSize: "20px",
                          lineHeight: "1.7",
                          fontWeight: "400",
                          maxWidth: "700px",
                        }}
                      >
                        "The complete renovation of all blocks in Valparai by RED ANT STUDIO LLP has brought new life to our campus. Their team carefully studied the unique climatic conditions of Valparai and delivered designs perfectly suited to its environment. Every block now feels modern, functional, and resilient, 
                        backed by their dedication, attention to detail, and seamless project coordination. We are truly grateful for their commitment to quality and community impact."
                      </div>

                      <div className="author">
                        <div className="au-img">
                          <img src="/home1/assets/img/team/icon.jpg" alt="" className="img-cover" />
                        </div>
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">xxx</h6>
                          <p className="text-capitalize fsz-14 color-666">
                            School Principal, Valparai
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div className="slider-controls">
                  <div className="swiper-button-prev"></div>
                  <div className="swiper-pagination"></div>
                  <div className="swiper-button-next"></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="marq-slider">
        <div className="swiper-wrapper">
          <div className="swiper-slide"><a href="#"> Creative </a></div>
          <div className="swiper-slide"><a href="#"> Flexible </a></div>
          <div className="swiper-slide"><a href="#"> Dedicated </a></div>
        </div>
      </div>

      <img src="/home1/assets/img/c_line3.png" alt="" className="c-line" />
    </section>
  );
}

export default Testimonials;


